import { BASE_URL_SETTING } from '../routes.constants'
import type { Route } from '~/interfaces/routes.interfaces'

const base = `${BASE_URL_SETTING}/author`

export const SETTINGS_AUTHOR: Route = {
  path: base
}

export const SETTINGS_AUTHOR_CREATE: Route = {
  path: `${base}/create`
}

export const SETTINGS_AUTHOR_EDIT: Route = {
  path: `${base}/{id}`
}
